import React, { ReactNode } from 'react'
import * as styles from './Cta.module.scss'
import PlayIcon from './assets/play.svg'

interface CtaProps {
  content: ReactNode
  className?: string
  dataTest?: string
}
const Cta: React.FC<CtaProps> = ({ content, className = '', dataTest = '' }: CtaProps) => {
  return (
    <a
      data-test={dataTest}
      className={`${styles.cta} ${className}`}
      href='/ide/puzzle/onboarding'
    >
      <PlayIcon />
      {content}
    </a>
  )
}

export default Cta
